<template>
  <div class="info-modal__content__title">
    <h4>{{ $t('modal_content.employer_tax_deduction.title') }}</h4>
  </div>
  <div class="info-modal__content__text">
    {{ $t('modal_content.employer_tax_deduction.text') }}
  </div>
</template>

<script setup lang="ts"></script>
